export enum BPLoggerFlowType {
  OrderToCash = 'order_to_cash',
  ReturnToRefund = 'return_to_refund',
  ProcureToPay = 'procure_to_pay',
  DemandToSupply = 'demand_to_supply',
  ProspectToCustomer = 'prospect_to_customer',
  IdeaToMarket = 'idea_to_market',
}
